<template>
    <!-- <div ref="previewContainer" style="width: 100%;"> -->
    <!-- <iframe v-if="generatedInvoice"
                ref="invoiceIframe"
            @load="resizeIframe($refs.invoiceIframe)"
            frameborder="0"
            scrolling="no"
            :srcdoc="generatedInvoice"
            style="box-shadow: 0 0 5px;"
        >
        </iframe> -->
    <!-- <div :style="{width: '100%', height: `auto`}">
            <div  v-if="generatedInvoice" ref="fullPage" :style="{width: '100%', height: `auto`}">
                <div :style="{width: '100%'}"v-html="generatedInvoice">
                </div>
            </div>
        </div> -->
    <div :style="{ width: '100%', height: `auto` }">
        <div
            v-if="fullPage"
            ref="fullPage"
            :style="{
                width: '100%',
                height: `auto`,
                position: 'absolute',
                left: '-100vw',
                top: '-100vh',
            }"
        >
            <div :style="{ width: '100%' }" v-html="fullPage" />
        </div>

        <div
            v-if="generatedInvoice"
            ref="htmlWrapper"
            class="htmlWrapper"
            :style="{ width: '100%', height: `${this.height}`, maxHeight: `${this.height}` }"
        >
            <div :style="{ width: '100%' }" v-html="generatedInvoice" />
        </div>
        <span class="text-center" v-else>Prévisualisation indisponible</span>

        <div
            v-if="!hideExtraDocument"
            v-show="generatedInvoice && pdfSrc && invoiceThemeSettings.appendix.includeAppendix"
            :key="pdfSrc"
        >
            <div>
                <pdf
                    :source="pdfSrc"
                    :key="pdfSrc"
                    v-if="pdfSrc"
                    style="width: 100%; margin-top: 12px; box-shadow: 0 0 5px"
                />
            </div>
        </div>
        <div
            ref="a4Ref"
            style="
                z-index: -1000;
                width: 210mm;
                left: -100%;
                top: -100%;
                position: absolute;
                height: 0;
            "
        />
    </div>

    <!-- </div> -->
</template>

<script lang="ts">
import Logo from "../configuration/Logo.vue";
import InvoiceHtmlBuilder from "../../../../backend/src/common/invoiceTheme/InvoiceHtmlBuilder";
import pdf from "vue-pdf-embed";
import DeliveryNoteHtmlBuilder from "../../../../backend/src/common/invoiceTheme/DeliveryNoteHtmlBuilder";
// import InvoiceThemeFrontService from "@/services/invoiceThemeFrontServices"
import InvoiceThemeService from "../../../../backend/src/common/invoiceTheme/invoiceThemeService";
import InvoiceThemeFrontService from "@/services/invoiceThemeFrontServices";
import InventoryListHtmlBuilder from "../../../../backend/src/common/invoiceTheme/InventoryListHtmlBuilder";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

@Component({
    components: {
        Logo,
        pdf,
    },
    emits: ["dom-info", "html-generated"],
})
export class InvoiceHtmlTemplateView extends Vue {
    @Prop({ default: () => {} }) invoiceThemeSettings: any;
    @Prop({ default: () => {} }) invoiceData: any;
    @Prop({ default: () => {} }) quotation: any;
    @Prop({ default: () => {} }) company: any;
    @Prop({ default: false, type: Boolean }) hideExtraDocument: boolean;
    @Prop({ default: false }) forPrint: boolean;
    @Prop({ default: null }) backgroundImage: string;
    @Prop({ default: null }) additionalDocument: string;
    @Prop({ default: null }) editedElementClass: string;

    previewScaleSize = 1;
    maxDisplayBoxHeight = null;
    maxDisplayBoxWidth = null;
    pdfPagesCount = 1;
    nInvoicePages = 0;
    pdfSrc: any = null;

    renderingInfo = InvoiceThemeService.defaultRenderingInfo();

    firstRender = false;

    get backgroundImageUrl() {
        return this.backgroundImage;
    }

    get height() {
        const val = `calc(297mm * ${this.nInvoicePages * this.previewScaleSize} + 3mm * ${
            this.nInvoicePages - 1
        })`;
        return val;
    }

    get clientHeight() {
        return document.getElementById("previewWrapper")?.clientHeight || 0;
    }

    async beforeMount() {
        this.updatePreviewScaleSize();
        window.addEventListener("resize", this.updatePreviewScaleSize);

        this.updatePdfView();

        this.maxDisplayBoxHeight = this.clientHeight * (this.previewScaleSize ?? 1);

        // if (!this.firstRender) {
        // this.extraPageSizeInfoFromDom()
        await this.$nextTick(); // Important so that extraction is made once fully loaded
        this.extraPageSizeInfoFromDomHelper();
        // }

        this.onPdfSrcChange();
    }

    emitDomInfo() {
        this.$emit("dom-info", this.renderingInfo);
    }

    @Watch("invoiceThemeSettings", { deep: true })
    // @Watch("invoiceData", {deep: true})
    @Watch("fullPage")
    async extraPageSizeInfoFromDom() {
        // Important to extract on next tick as immediately after change, the model page (fullPage) may not be fully rendered
        // Table rows for instance are rendered late, the initial size may be incorrect.
        await this.$nextTick();
        this.extraPageSizeInfoFromDomHelper();
        // this.$nextTick(() => this.extraPageSizeInfoFromDomHelper())
    }

    extraPageSizeInfoFromDomHelper() {
        const startTime = +new Date();

        const invoicePageRef = this.$refs.fullPage as any;

        if (!invoicePageRef) {
            return null;
        }
        const invoiceThemeFrontService = new InvoiceThemeFrontService();

        invoiceThemeFrontService.setObjInfoFromEl(this.renderingInfo.document, invoicePageRef);
        const pageEl = invoicePageRef.querySelector("#fullPage");
        invoiceThemeFrontService.setObjInfoFromEl(this.renderingInfo.page, pageEl);

        const res = invoiceThemeFrontService.extractPageSizeInfoFromDom(
            invoicePageRef,
            this.renderingInfo,
        );
        if (res) {
            this.firstRender = true;

            this.emitDomInfo();
        }

        const endTime = +new Date();

        // console.log("Extraction time", endTime - startTime, "startTime", startTime, "endTime", endTime, )
    }

    numberOfPages(val) {
        this.pdfPagesCount = val ?? 1;
    }

    // pdfRefreshKey = 0

    // @Watch("pdfSrc")
    // updatePdfRefreshkey(newVal, oldVal) {
    //     if (newVal !== oldVal) {
    //         this.pdfRefreshKey += 1
    //     }
    //     console.log("pdfRefreshKey", this.pdfRefreshKey)
    // }

    updatePdfView() {
        if (this.additionalDocument && !this.hideExtraDocument) {
            this.pdfSrc = this.additionalDocument;
        }
    }

    @Watch("invoiceThemeSettings.appendix.includeAppendix")
    @Watch("additionalDocument", { immediate: true })
    async onPdfSrcChange() {
        if (
            this.additionalDocument &&
            this.invoiceThemeSettings.appendix.includeAppendix &&
            !this.hideExtraDocument
        ) {
            this.pdfSrc = null;
            // await this.$nextTick()
            // this.$nextTick(() => {this.pdfSrc = this.additionalDocument})
            // this.pdfSrc = this.additionalDocument
            const timeout = setTimeout(() => {
                this.pdfSrc = this.additionalDocument;
                clearTimeout(timeout);
            }, 100);
        }
        // console.log("pdfSrc", this.pdfSrc)
        this.updatePreviewScaleSizeHelper(true);
        // this.updated_()
    }

    updated_() {
        if (!this.hideExtraDocument) {
            this.updatePdfView();
        }
        this.updatePreviewScaleSizeHelper(true);
    }

    // updated() {
    //     // this.updated_()
    // }

    beforeDestroy() {
        window.removeEventListener("resize", this.updatePreviewScaleSize);
    }

    updatePreviewScaleSizeHelper(update = false) {
        // const padding = 0
        const a4Width = this.getComponentWidth(this.$refs.a4Ref);
        const componentContainer = this.getComponentDirectContainer();
        let padding = 0;
        try {
            padding = !componentContainer
                ? 0
                : parseFloat(window.getComputedStyle(componentContainer).paddingLeft) +
                  parseFloat(window.getComputedStyle(componentContainer).paddingRight);
        } catch (error) {
            // console.error(error)
        }
        const parentWidth = this.getComponentWidth(componentContainer) - padding;
        // console.log("componentContainer", componentContainer, "parentWidth", parentWidth, "a4Width", a4Width)
        // const ratio = Math.min(1, (a4Width && parentWidth) ? parentWidth / a4Width : 1)
        const ratio = a4Width && parentWidth ? parentWidth / a4Width : 1;
        // console.log("ratio", ratio)
        this.previewScaleSize = ratio;

        // const a4Height = this.getComponentHeight(this.$refs.a4Ref)
        // this.maxDisplayBoxHeight = a4Height * ratio
        this.maxDisplayBoxHeight = "auto";
        this.maxDisplayBoxWidth = a4Width * ratio;
        if (!update) {
            this.maxDisplayBoxHeight = this.clientHeight * (this.previewScaleSize ?? 1);
        }
    }

    updatePreviewScaleSize() {
        this.updatePreviewScaleSizeHelper(false);
    }

    getComponentWidth(compRef) {
        if (compRef) {
            return compRef.clientWidth;
        }
        return null;
    }

    getComponentHeight(compRef) {
        if (compRef) {
            return compRef.clientHeight;
        }
        return null;
    }

    getComponentDirectContainer() {
        return this.$el?.parentElement;
    }

    // // @Watch("firstRender", {immediate: true})
    // @Watch("invoiceThemeSettings", {deep: true})
    // @Watch("invoiceData", {deep: true})
    // @Watch("previewScaleSize")
    // @Watch("renderingInfo", {deep: true})
    generateHtml({ forPrint = false }) {
        // this.extraPageSizeInfoFromDom(this.$refs.fullPage)
        let htmlService;
        if (this.invoiceData?.type === "BILL_DELIVERY") {
            htmlService = new DeliveryNoteHtmlBuilder(
                forPrint,
                this.invoiceThemeSettings,
                this.invoiceData,
                this.quotation,
                this.company,
                this.previewScaleSize,
                true,
                this.backgroundImageUrl,
                this.editedElementClass,
                this.firstRender ? this.renderingInfo : null,
            );
        } else if (this.invoiceData?.type === "INVENTORY") {
            htmlService = new InventoryListHtmlBuilder(
                false,
                this.invoiceThemeSettings,
                this.invoiceData,
                this.quotation,
                this.company,
                this.previewScaleSize,
                true,
                this.backgroundImageUrl,
                this.editedElementClass,
                this.firstRender ? this.renderingInfo : null,
            );
        } else {
            htmlService = new InvoiceHtmlBuilder(
                forPrint,
                this.invoiceThemeSettings,
                this.invoiceData,
                this.quotation,
                this.company,
                this.previewScaleSize,
                true,
                this.backgroundImageUrl,
                this.editedElementClass,
                this.firstRender ? this.renderingInfo : null,
            );
        }
        const html = htmlService.generateHtmlTemplate();
        // const html = htmlService.generateFullSinglePageHtmlTemplate()
        this.nInvoicePages = htmlService.nPages;
        this.$emit("html-generated", html);
        return html;
    }

    get generatedInvoice() {
        const html = this.generateHtml({ forPrint: false });
        // console.log("themesettings", this.invoiceThemeSettings, "invoiceData", this.invoiceData, "company", this.company, "quotation", this.quotation, "domInfo", this.renderingInfo)
        return html;
    }

    get fullPage() {
        let htmlService;
        if (this.invoiceData?.type === "BILL_DELIVERY") {
            htmlService = new DeliveryNoteHtmlBuilder(
                false,
                this.invoiceThemeSettings,
                this.invoiceData,
                this.quotation,
                this.company,
                this.previewScaleSize,
                true,
                this.backgroundImageUrl,
                this.editedElementClass,
                null,
            );
        } else if (this.invoiceData?.type === "INVENTORY") {
            htmlService = new InventoryListHtmlBuilder(
                false,
                this.invoiceThemeSettings,
                this.invoiceData,
                this.quotation,
                this.company,
                this.previewScaleSize,
                true,
                this.backgroundImageUrl,
                this.editedElementClass,
                null,
            );
        } else {
            htmlService = new InvoiceHtmlBuilder(
                false,
                this.invoiceThemeSettings,
                this.invoiceData,
                this.quotation,
                this.company,
                this.previewScaleSize,
                true,
                this.backgroundImageUrl,
                this.editedElementClass,
                null,
            );
        }
        const html = htmlService.generateFullSinglePageHtmlTemplate();
        return html;
    }

    // @Watch("additionalDocument")
    // async downloadPdfData() {
    //     console.log("Fetching ....................")
    //     if (!this.additionalDocument) {
    //         return
    //     }
    //     const self = this
    //     fetch(this.additionalDocument)
    //         .then(response => response.blob())
    //         .then(blob => {
    //             console.log("blob", blob)
    //             const reader = new FileReader();
    //             reader.onloadend = function () {
    //                 const base64Data = (reader.result as string).split(',')[1];
    //                 // const embedElement = document.getElementById('pdf-embed');
    //                 // embedElement.src = `data:application/pdf;base64,${base64Data}`;
    //                 self.$refs.embedPdf["src"] = `data:application/pdf;base64,${base64Data}`
    //             };
    //             reader.readAsDataURL(blob);
    //         })
    //         .catch(error => console.error('Error fetching the PDF:', error));
    // }
}

export default toNative(InvoiceHtmlTemplateView);
</script>
